import React from 'react';
import PropTypes from 'prop-types';

import {
  Typography,
} from '@material-ui/core';

import { ExecutionOutputChip } from '.';

export default function ExecutionOutputs(props) {
    
  const { value, variant } = props;

  if(!value) {
    return(<Typography variant='body2'>None</Typography>);
  }

  const datas=value.Data?value.Data.Objects:0;
  const dataBytes=value.Data?value.Data.Bytes:0;
  const dataLocation=value.Data?value.Data.Location:null;
  
  const artifacts=value.Artifacts?value.Artifacts.Objects:0;
  const artifactBytes=value.Artifacts?value.Artifacts.Bytes:0;
  const artifactLocation=value.Artifacts?value.Artifacts.Location:null;
  
  const samples=value.Samples?value.Samples.Objects:0;
  const sampleBytes=value.Samples?value.Samples.Bytes:0;
  const sampleLocation=value.Samples?value.Samples.Location:null;

  const diagnostics=value.Diagnostics?value.Diagnostics.Objects:0;
  const diagnosticBytes=value.Diagnostics?value.Diagnostics.Bytes:0;
  const diagnosticLocation=value.Diagnostics?value.Diagnostics.Location:null;

  const outputs=datas+artifacts+samples+diagnostics;

  if(!outputs) {
    return(null);
  }

  if(variant==='summary') {
    return (
      <React.Fragment>
        <ExecutionOutputChip type='Data' count={datas} size={dataBytes} location={dataLocation} />
        <ExecutionOutputChip type='Artifacts' count={artifacts} size={artifactBytes} location={artifactLocation} />
        <ExecutionOutputChip type='Samples' count={samples} size={sampleBytes} location={sampleLocation} />
        <ExecutionOutputChip type='Diagnostics' count={diagnostics} size={diagnosticBytes} location={diagnosticLocation} />
      </React.Fragment>
    );
  }
}

ExecutionOutputs.propTypes = {
  value: PropTypes.object,
  variant: PropTypes.string.isRequired,
};

ExecutionOutputs.defaultProps = {
  variant: 'summary',
};
